import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=43188dfc&"
import script from "./ComingSoon.vue?vue&type=script&lang=js&"
export * from "./ComingSoon.vue?vue&type=script&lang=js&"
import style0 from "./ComingSoon.vue?vue&type=style&index=0&id=43188dfc&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43188dfc')) {
      api.createRecord('43188dfc', component.options)
    } else {
      api.reload('43188dfc', component.options)
    }
    module.hot.accept("./ComingSoon.vue?vue&type=template&id=43188dfc&", function () {
      api.rerender('43188dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/miscellaneous/ComingSoon.vue"
export default component.exports